"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _radio = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/radio"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaultNavigationWidth = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
  return _regenerator.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import('@insided/destination/modules/Customization/configurator/assets/DefaultNavigationWidth');

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
var FullNavigationWidth = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
  return _regenerator.default.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return import('@insided/destination/modules/Customization/configurator/assets/FullNavigationWidth');

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})));
var TEMPLATE_OPTIONS = [{
  id: 'default-width',
  visual: (0, _preact.h)(DefaultNavigationWidth, null),
  text: 'Default width'
}, {
  id: 'full-width',
  visual: (0, _preact.h)(FullNavigationWidth, null),
  text: '100% width'
}];

var NavigationWidth = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NavigationWidth, _Component);

  var _super = _createSuper(NavigationWidth);

  function NavigationWidth() {
    var _this;

    (0, _classCallCheck2.default)(this, NavigationWidth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedTemplateOption: _this.props.selectedTemplate
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeTemplate", function (idx) {
      _this.setState({
        selectedTemplateOption: idx
      }, _this.onChangeSend);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeSend", function () {
      _this.props.onLayoutChange(_this.state.selectedTemplateOption);
    });
    return _this;
  }

  (0, _createClass2.default)(NavigationWidth, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedTemplateOption = this.state.selectedTemplateOption;
      return (0, _preact.h)("div", {
        className: "widget-configurator_tab-template"
      }, (0, _preact.h)("strong", null, "Navigation Width"), (0, _preact.h)(_radio.RadioGroup, {
        spacing: "L",
        direction: "horizontal"
      }, TEMPLATE_OPTIONS.map(function (option, id) {
        return (0, _preact.h)("div", {
          className: "template-selector ".concat(id === _this2.state.selectedTemplateOption ? 'checked' : ''),
          key: option.id
        }, (0, _preact.h)(_radio.default, {
          id: "parent-child-".concat(option.id),
          label: "label 2",
          name: "card-selector",
          inputPosition: "top",
          value: (0, _preact.h)("div", {
            className: "template-selector-card"
          }, option.visual, (0, _preact.h)("div", null, option.text)),
          isChecked: id === selectedTemplateOption,
          onClick: function onClick() {
            return _this2.onChangeTemplate(id);
          }
        }));
      })));
    }
  }]);
  return NavigationWidth;
}(_preact.Component);

var _default = NavigationWidth;
exports.default = _default;